import { Path, Svg } from "@react-pdf/renderer"

type CalendarRangeIconPDFProps = {
	width?: number
	height?: number
	stroke?: string
	fill?: string
}

export const CalendarRangeIconPDF: React.FC<CalendarRangeIconPDFProps> = ({
	width = 24,
	height = 24,
	stroke = "black",
	fill,
}) => {
	return (
		<Svg width={width} height={height} viewBox="0 0 24 24" fill={fill}>
			<Path
				d="M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z"
				stroke={stroke}
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<Path
				d="M16 2V6"
				stroke={stroke}
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<Path
				d="M8 2V6"
				stroke={stroke}
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<Path
				d="M3 10H21"
				stroke={stroke}
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<Path
				d="M17 14H11"
				stroke={stroke}
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<Path
				d="M13 18H7"
				stroke={stroke}
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<Path
				d="M7 14H7.01"
				stroke={stroke}
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<Path
				d="M17 18H17.01"
				stroke={stroke}
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Svg>
	)
}
